export const BOOKING_UNLOCK_THRESHOLD_MINUTES = 15;
export const BOOKING_UNLOCK_GRACE_PERIOD_HOURS = 12;
export const AUTH_STATION_SLUG_HEADER = "x-auth-station-slug";
/**
 * Delay after the booking has started, before the end booking process can be started.
 * We've set this to 0 for now, after first tests with Markus.
 * If we keep it like that, we should remove the delay feature.
 */
export const END_BOOKING_PROCESS_AVAILABLE_DELAY_AFTER_START_MINUTES = 0;
